<template>
	<v-container>
		<v-data-table 
			class="elevation-1" 
			:headers="encabezados" 
			:items="llamadas" 
			:items-per-page="5" 
			:multi-sort="true"
			@click:row="llamadasPendientes"
		>
		</v-data-table>
	</v-container>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi.js'
export default{
	name: 'LlamadasSeguimiento',
	data: () => ({
		encabezados : [
			{text: 'Folio', value: 'folio'},
			{text: 'Fecha de Solicitud', value: 'fechaSolicitud'},
			{text: 'Paciente', value: 'paciente'},
			{text: 'Teléfono 1', value: 'tel1'},
			{text: 'Teléfono 2', value: 'tel2'},
			{text: 'Teléfono 3', value: 'tel3'},
			{text: 'Estatus', value: 'status'},
			{text: 'Núm. Llam.', value: 'numLlamada'}
		],
		llamadas: [],
		respuesta: '',
	}),
	mounted: function() {
		ServiciosApi.llamadasSeguimiento()
			.then(response => {
				this.respuesta = response.data
				if(this.respuesta.status === 'ok'){
					this.llamadas = this.respuesta.datos
				}
			})
			.catch(error => {
				console.log("Hubieron errores", error.response)
			})
	},
	methods: {
		llamadasPendientes(event){
			let solicitudEnSeguimiento = {
				idSolicitud: event.folio,
				fechaSolicitud: event.fechaSolicitud,
				paciente: event.paciente,
				tel1: event.tel1,
				tel2: event.tel2,
				tel3: event.tel3,
				status: event.status
			}
			//console.log("llamadas Pendientes", solicitudEnSeguimiento)
			this.$emit('llamada-seleccionada', solicitudEnSeguimiento)
		}
	}
}
</script>
